export { useGetSolutionTypes } from '@dc-shared-web/hooks/api/solutionType/useGetSolutionTypes'
export { useGetSolutionTypeTemplates } from '@dc-shared-web/hooks/api/solutionType/useGetSolutionTypeTemplates'
export { fetchSolutionTypes } from '@dc-shared-web/hooks/api/solutionType/fetchSolutionType'

export type {
  SolutionType,
  SolutionTypeTemplate,
} from '@dc-shared-web/hooks/api/solutionType/types'
